import {Button, Card, CardBody, CardFooter, CardHeader, Input, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Validator from "../helper/validator/Validator";
import {ValidatorProvider} from "../helper/validator/ValidatorContext";
import {Toaster} from "../helper/Toaster";
import Dict from "../helper/dict";
import {updateForgotPassword} from "../services/user/change_password";
import OtpField from "../components/system/otpField";
import {useNavigate} from "react-router-dom";
import PasswordField from "../components/system/passwordField";
import {checkAll} from "../helper/validator/Check";

const ForgotPassword = () => {
  const backgroundPhoto = '/assets/login-background.jpeg';

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [code, setCode] = useState("");
  const [codeSent, setCodeSent] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('userInfo')) {
      if (localStorage.getItem('expiration')) {
        if (localStorage.getItem('token')) {
          window.location.href = "/";
        }
      }
    }
  }, []);

  const changePassword = async () => {
    const res = checkAll();
    if (!res) {
      Toaster.failure(null, <Typography variant={"small"}>
        مقادیر الزامی را بر اساس راهنما تکمیل کنید
      </Typography>);
      return
    }
    const data = {
      phone: phone, code: code, password: password, confirmPassword: confirmPassword,
    };

    let result;

    result = await updateForgotPassword(data);

    if (result.status === 200) {

      navigate("/login", {state: {source: "forgotPassword"}});
    }
  };


  // const validatorRef = useRef(null);
  const handleSubmit = () => {
    const res = checkAll();
    if (!res) {
      Toaster.failure(null, <Typography variant={"small"}>
        مقادیر الزامی را بر اساس راهنما تکمیل کنید
      </Typography>);
    }
  };

  return (
    <ValidatorProvider>
      <div className={"flex justify-center items-center h-screen"}
           style={{backgroundImage: `url(${backgroundPhoto})`}}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <Card className="flex w-full mx-4 md:w-2/3">
          <CardHeader variant="gradient" color="gray" className="mb-4 pt-4 grid place-items-center">
            <Typography variant="h3" color="white" className="pt-4 mb-4">
              بازنشانی رمزعبور
            </Typography>
          </CardHeader>
          <CardBody className="flex flex-col gap-4 py-8 px-4">
            <Input variant="standard" type="number" label={Dict('phone')} size="lg" value={phone}
                   onChange={(e) => setPhone(e.target.value)}
                   className="appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                   disabled={codeSent}
            />
            <Validator state={phone} rules="required|persianNum|mobile"/>
            <div className="flex flex-row w-full">
              <OtpField time={300} onChange={setCode} userPhone={phone} setCodeSent={setCodeSent}/>
            </div>
            {codeSent === true &&
              <>
                <PasswordField label={Dict('password')} size="lg" value={password} onChange={setPassword}/>
                <Validator state={password} rules="required|password"/>
                <PasswordField label={Dict('confirm_password')} size="lg" value={confirmPassword}
                               onChange={setConfirmPassword}/>
                <Validator state={confirmPassword} rules={`required|matches=${password}`}/>
              </>
            }
          </CardBody>
          <CardFooter className="pt-0">
            {codeSent === true &&
              <Button variant="gradient" fullWidth className="mb-4" onClick={changePassword}>
                تغییر رمز عبور
              </Button>
            }
            <Typography variant="small" className="mt-6 flex justify-center">
              <a href="/login" className="mx-2 font-bold">بازگشت به صفحه ورود</a>
            </Typography>
          </CardFooter>
        </Card>
        {/*<Validator ref={validatorRef} />*/}
      </div>
    </ValidatorProvider>);
};

export default ForgotPassword;
